import React, { useState, useEffect } from 'react'
import { IoMdClose } from "react-icons/io";
import { formatPrice, formatPricewithdecimal } from '../../../../NumberFormat';
import { withTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import ErrorCodePopup from '../../../../Popups/ErrorCodePopup';
const QuickBuyPopup = (props) => {
  const { onClose, response } = props;
  const submitResult = response[0];

  const [mainLabel, setMainLabel] = useState('');
  const [label, setLabel] = useState('');
  const [totalPay, setTotalPay] = useState('');
  const [successResultData, setSuccessResultData] = useState([]);
  const [canceledResultData, setCanceledResultData] = useState([]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  useEffect(() => {
    if (submitResult.nextPeriode && submitResult.game_code) {
      setMainLabel('Process Done (Quick Buy ' + submitResult.game_name + ')  - >>');
      setLabel(`${props.t('period')}` + ': ' + (submitResult.nextPeriode) + ' - ' + submitResult.game_code);
      setTotalPay(submitResult.totalbayar);
    }

    if (submitResult.datasuccess) {
      const successData = (submitResult.datasuccess)[submitResult.game_id] ?? [];
      setSuccessResultData(successData);
    }

    if (submitResult.datafailed) {
      const cancelData = (submitResult.datafailed)[submitResult.game_id] ?? [];
      setCanceledResultData(cancelData);
    }
  }, [submitResult.datasuccess, submitResult.datafailed]);

  const handlePopupOpen = (redValue) => {
    let message;
    let code = '';
    code = 'code' + redValue;
    let popupMessage = props.t(code);
    setPopupMessage(popupMessage);
    setIsPopupOpen(true);
  };

  const handlePopupClose = () => {
    setIsPopupOpen(false);
    setPopupMessage('');
  };

  const headerMappings = {
    '4d3d2d': ['4D/3D/2D'],
    'colokbebas': ['Colok Bebas'],
    'colokbebas2d': ['Colok Bebas 2D'],
    'colokjitu': ['Colok Jitu'],
    'coloknaga': ['Colok Naga'],
    '5050': ['50-50'],
    '50502d': ['50-50 2D'],
    'macaushio': ['Macau Shio'],
    'shio': ['Shio'],
    'tengahtepi': ['Tengah / Tepi'],
    'kombinasi': ['Kombinasi'],
    'quick4d': ['Quick 4D'],
    'bbcampuran': ['BB Campuran'],
    'silanghomo': ['Silang / Homo'],
  };

  // Define a shared column configuration
  const cancelColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet') },
    { key: 'amount', label: props.t('amount') },
    { key: 'error_code', label: props.t('error_code') },
    { key: 'Description', label: props.t('Description') }
  ];

  const cancelColokBebas2dColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet1') },
    { key: 'bet2', label: props.t('bet2') },
    { key: 'amount', label: props.t('amount') },
    { key: 'error_code', label: props.t('error_code') },
    { key: 'Description', label: props.t('Description') }
  ];

  const cancelColokNagaColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet1') },
    { key: 'bet2', label: props.t('bet2') },
    { key: 'bet3', label: props.t('bet3') },
    { key: 'amount', label: props.t('amount') },
    { key: 'error_code', label: props.t('error_code') },
    { key: 'Description', label: props.t('Description') }
  ];

  const cancelColokJituColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet') },
    { key: 'posisi', label: props.t('posisi') },
    { key: 'amount', label: props.t('amount') },
    { key: 'error_code', label: props.t('error_code') },
    { key: 'Description', label: props.t('Description') }
  ];

  const cancelColumnConfig5050 = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet') },
    { key: 'kei', label: props.t('kei') + ' (%)' },
    { key: 'amount', label: props.t('amount') },
    { key: 'error_code', label: props.t('error_code') },
    { key: 'Description', label: props.t('Description') }
  ];

  // Define title mappings to the shared configuration
  const cancelHeaderColumnConfig = {
    '4d3d2d': cancelColumnConfig,
    'colokbebas': cancelColumnConfig,
    'tengahtepi': cancelColumnConfig,
    'shio': cancelColumnConfig,
    '5050': cancelColumnConfig5050,
    '50502d': cancelColumnConfig5050,
    'silanghomo': cancelColumnConfig5050,
    'kombinasi': cancelColokBebas2dColumnConfig,
    'colokbebas2d': cancelColokBebas2dColumnConfig, //seperate
    'coloknaga': cancelColokNagaColumnConfig, //seperate
    'colokjitu': cancelColokJituColumnConfig //seperate
  };

  // Configuration for data field keys based on title
  const cancelDataColumnConfig = {
    '4d3d2d': ['index', 'bet', 'amount', 'error_code', 'Information'],
    'colokbebas': ['index', 'bet', 'amount', 'error_code', 'Information'],
    'colokbebas2d': ['index', 'bet', 'bet2', 'amount', 'error_code', 'Information'],
    'coloknaga': ['index', 'bet', 'bet2', 'bet3', 'amount', 'error_code', 'Information'],
    'colokjitu': ['index', 'bet', 'posisi', 'amount', 'error_code', 'Information'],
    '5050': ['index', 'bet', 'kei', 'amount', 'error_code', 'Information'],
    '50502d': ['index', 'bet', 'kei', 'amount', 'error_code', 'Information'],
    'silanghomo': ['index', 'bet', 'kei', 'amount', 'error_code', 'Information'],
    'shio': ['index', 'bet', 'amount', 'error_code', 'Information'],
    'tengahtepi': ['index', 'bet', 'amount', 'error_code', 'Information'],
    'kombinasi': ['index', 'bet', 'bet2', 'amount', 'error_code', 'Information'],
  };

  // Define a shared column configuration
  const sharedColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet') },
    { key: 'amount', label: props.t('amount') },
    { key: 'disc', label: props.t('discount') + ' (%)' },
    { key: 'bayar', label: props.t('pay') },
    { key: 'totalWin', label: props.t('totalWin') }
  ];

  const colokBebas2dColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet1') },
    { key: 'bet2', label: props.t('bet2') },
    { key: 'amount', label: props.t('amount') },
    { key: 'disc', label: props.t('discount') + ' (%)' },
    { key: 'bayar', label: props.t('pay') },
    { key: 'totalWin', label: props.t('totalWin') }
  ];

  const colokNagaColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet1') },
    { key: 'bet2', label: props.t('bet2') },
    { key: 'bet3', label: props.t('bet3') },
    { key: 'amount', label: props.t('amount') },
    { key: 'disc', label: props.t('discount') + ' (%)' },
    { key: 'bayar', label: props.t('pay') },
    { key: 'totalWin', label: props.t('totalWin') }
  ];

  const colokJituColumnConfig = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet') },
    { key: 'posisi', label: props.t('posisi') },
    { key: 'amount', label: props.t('amount') },
    { key: 'disc', label: props.t('discount') + ' (%)' },
    { key: 'bayar', label: props.t('pay') },
    { key: 'totalWin', label: props.t('totalWin') }
  ];

  const columnConfig5050 = [
    { key: 'index', label: 'No' },
    { key: 'bet', label: props.t('bet') },
    { key: 'amount', label: props.t('amount') },
    { key: 'kei', label: props.t('kei') + ' (%)' },
    { key: 'disc', label: props.t('discount') + ' (%)' },
    { key: 'bayar', label: props.t('pay') },
    { key: 'totalWin', label: props.t('totalWin') }
  ];

  // Configuration for data field keys based on title
  const dataColumnConfig = {
    '4d3d2d': ['index', 'bet', 'amount', 'disc', 'bayar', 'totalwin'],
    'colokbebas': ['index', 'bet', 'amount', 'disc', 'bayar', 'totalwin'],
    'colokbebas2d': ['index', 'bet', 'bet2', 'amount', 'disc', 'bayar', 'totalwin'],
    'coloknaga': ['index', 'bet', 'bet2', 'bet3', 'amount', 'disc', 'bayar', 'totalwin'],
    'colokjitu': ['index', 'bet', 'posisi', 'amount', 'disc', 'bayar', 'totalwin'],
    '5050': ['index', 'bet', 'amount', 'kei', 'disc', 'bayar', 'totalwin'],
    '50502d': ['index', 'bet', 'amount', 'kei', 'disc', 'bayar', 'totalwin'],
    'silanghomo': ['index', 'bet', 'amount', 'kei', 'disc', 'bayar', 'totalwin'],
    'shio': ['index', 'bet', 'amount', 'disc', 'bayar', 'totalwin'],
    'tengahtepi': ['index', 'bet', 'amount', 'disc', 'bayar', 'totalwin'],
    'kombinasi': ['index', 'bet', 'bet2', 'amount', 'disc', 'bayar', 'totalwin'],
  };

  // Define title mappings to the shared configuration
  const headerColumnConfig = {
    '4d3d2d': sharedColumnConfig,
    'colokbebas': sharedColumnConfig,
    'tengahtepi': sharedColumnConfig,
    'shio': sharedColumnConfig,
    '5050': columnConfig5050,
    '50502d': columnConfig5050,
    'silanghomo': columnConfig5050,
    'kombinasi': colokBebas2dColumnConfig,
    'colokbebas2d': colokBebas2dColumnConfig, //seperate
    'coloknaga': colokNagaColumnConfig, //seperate
    'colokjitu': colokJituColumnConfig //seperate
  };

  const getHeaderColumnConfig = (title) => headerColumnConfig[title] || [];
  const getDataColumnKeys = (title) => dataColumnConfig[title] || [];

  const getCancelHeaderColumnConfig = (title) => cancelHeaderColumnConfig[title] || [];
  const getCancelDataColumnKeys = (title) => cancelDataColumnConfig[title] || [];

  const renderTable = (title, data) => {
    const columns = getHeaderColumnConfig(title);
    const dataColumnKeys = getDataColumnKeys(title);
    const header = headerMappings[title] || Object.keys(data[0] || {});
    return (
      <div className="table-container" style={{ width: "100%" }}>
        <h2 className="quickbut_txt">{header} {label} Success</h2>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ display: "table", width: "100%", tableLayout: "fixed" }}>
            <tr>
              {columns.map(col => (
                <th key={col.key}>{props.t(col.label)}</th>
              ))}
            </tr>
          </thead>
          <tbody style={{ display: "block", width: "100%" }}>
            {data.map((row, index) => (
              <tr style={{ display: 'table', width: '100%', tableLayout: 'fixed' }} key={index}
                className={index % 2 === 0 ? "even-row" : "odd-row"}>
                {dataColumnKeys.map(key => (
                  <td key={key}>
                    {key === 'index' ? index + 1 :
                      // Format specific columns based on key
                      key === 'amount' || key === 'bayar' || key === 'totalwin' ? formatPricewithdecimal(row[key]) :
                        // Use default formatting if necessary
                        row[key] !== undefined ? row[key] : '-'
                    }
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  const renderTable1 = (title, data) => {
    const cancelColumns = getCancelHeaderColumnConfig(title);
    const cancelDataColumnKeys = getCancelDataColumnKeys(title);
    const header = headerMappings[title] || Object.keys(data[0] || {});
    return (
      <div className="table-container" style={{ width: "100%" }}>
        <h2 className="quickbut_txt">{header} {label} Cancelled</h2>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ display: "table", width: "100%", tableLayout: "fixed" }}>
            <tr>
              {cancelColumns.map(col => (
                <th key={col.key}>{props.t(col.label)}</th>
              ))}
            </tr>
          </thead>
          <tbody style={{ display: "block", width: "100%" }}>
            {data.map((row, index) => (
              <tr style={{ display: 'table', width: '100%', tableLayout: 'fixed' }} key={index}
                className={index % 2 === 0 ? "even-row" : "odd-row"}>
                {cancelDataColumnKeys.map(key => (
                  <td key={key}>
                    {key === 'index' ? index + 1 :
                      // Format specific columns based on key
                      key === 'amount' ? formatPrice(row[key]) :

                        key === 'error_code' ? <a className='link' onClick={() => handlePopupOpen(row.red)}>{props.t('click_here')} ({row.red || 14})</a> :

                          key === 'Information' ? (row.red == 14 ? <span style={{ color: "red" }}>{props.t("Removed")}</span> : <span style={{ color: "red" }}>{props.t("Eliminate")}</span>) :
                            // Use default formatting if necessary
                            row[key] !== undefined ? row[key] : '-'
                    }
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      {(canceledResultData && Object.keys(canceledResultData).length > 0) || (successResultData && Object.keys(successResultData).length > 0) ? (
        <div className="bbfs_popup">
          <button className="informasi_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose"/>
          </button>
          <div className="bbfs_popup_titleone">{mainLabel}</div>
          <div className='trasaction_popup'>
            {canceledResultData && (
              <>
                <div className="informasi_tble_result statement_tble_result">
                  {Object.keys(canceledResultData).map((key) => {
                    const data = canceledResultData[key];
                    if (data.length > 0) {
                      return renderTable1(key, data);
                    }
                    return null;
                  })}
                </div>
              </>
            )}

            {successResultData && (
              <>
                <div className="informasi_tble_result statement_tble_result">
                  {Object.keys(successResultData).map((key) => {
                    const data = successResultData[key];
                    if (data.length > 0) {
                      return renderTable(key, data);
                    }
                    return null;
                  })}
                </div>
              </>
            )}
          </div>
          <div className='bbfs_popup_total'>Total {props.t('player_pay')} : {formatPricewithdecimal(totalPay)}</div>
        </div>
      ) : null}
      {isPopupOpen &&
        (<ErrorCodePopup onClose={handlePopupClose} message={popupMessage} />)
      }
    </div>
  );
};

export default withTranslation()(QuickBuyPopup);
